import client from '../client';

export interface ExchangeRateCurrencyResponse {
  id: number;
  vender_id: number;
  rate_in: number;
  rate_out: number;
  created_at: string;
  updated_at: string;
}

export default function API(): Promise<ExchangeRateCurrencyResponse> {
  return client.get(`exchange_rate_currency/get_rate_member`).then((response) => response.data);
}
